import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DetailedSettlementReportRoutingModule } from './detailed-settlement-report-routing.module';
import { DetailedSettlementReportComponent } from './detailed-settlement-report.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { ReportModule } from '../report.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    DetailedSettlementReportRoutingModule,
    ReportModule
  ],
  declarations: [DetailedSettlementReportComponent],
  entryComponents:[]
})
export class DetailedSettlementReportModule { }
